interface Props {
  collapsed?: boolean;
  className?: string;
}

export default function Logo({ collapsed, className = "" }: Props) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {!collapsed && (
        <span className="text-xl font-extrabold tracking-tight text-white whitespace-nowrap">
          Mavelux <span className="text-citilux-blue-400">paints</span>
        </span>
      )}
      {collapsed && (
        <span className="text-lg font-extrabold text-citilux-blue-400">M</span>
      )}
    </div>
  );
}
